import { gql } from '@apollo/client'
import { message } from 'antd'
import { RowNode } from "@ag-grid-community/core";

import useMutationWithFeedback from 'shared-modules/general-hooks/useMutationWithFeedback'
import clone from 'lodash/clone';
import set from 'lodash/set';
const MUTATION = gql`
mutation MyMutation($id: uuid!) {
  delete_vendor_service_record_schedule_by_pk(id: $id) {
    vendorServiceRecord {
      schedules(order_by: {schedule_date: asc_nulls_last}) {
        id
        completed
        schedule_date
      }
    }
  }
}
`

const useDeleteRecordSchedule = (rowData: any, rowNode: RowNode) => {
  const { doAction, loading, error, data } = useMutationWithFeedback({
    mutation: MUTATION,
    onError: (error) => {
      console.error("useDeleteRecordSchedule ERROR:", error)
      message.error({ key: "useDeleteRecordSchedule", content: "An error occurred. Please try again.", duration: 2.5 })
    },
    onSuccess: (successData) => {
      message.success({ key: "useDeleteRecordSchedule", content: "Saved!", duration: 2.5 })
      rowNode.setData(set(clone(rowData), "record.schedules", successData.delete_vendor_service_record_schedule_by_pk.vendorServiceRecord.schedules))
    },
    onLoading: () => {
      message.loading({ key: "useDeleteRecordSchedule", content: "Saving...", duration: 0 })
    }
  })
  return { doAction, loading, error, data }
}

export default useDeleteRecordSchedule